/**
 * Analytics — GA4 sempre ativo; PostHog e Meta Pixel opcionais via .env / Vercel.
 */

/** Rastreia clique de lead no WhatsApp em GA4, Meta Pixel e PostHog. */
export function trackWhatsAppLead(section) {
  if (typeof window === 'undefined') return;

  if (window.gtag) {
    window.gtag('event', 'whatsapp_click', {
      event_category: 'lead',
      event_label: section,
      section,
    });
    window.gtag('event', 'generate_lead', {
      currency: 'BRL',
      value: 1,
      lead_source: section,
    });
  }

  if (window.fbq) {
    window.fbq('track', 'Contact', { content_name: section });
    window.fbq('track', 'Lead', { content_name: section });
  }

  if (window.posthog?.capture) {
    window.posthog.capture('whatsapp_click', { section });
  }
}

function initPostHog() {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key || String(key).trim() === '') {
    return;
  }

  const apiHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

  void (async () => {
    try {
      const mod = await import(
        /* webpackIgnore: true */
        'https://esm.sh/posthog-js@1.204.0',
      );
      const posthog = mod.default ?? mod;
      if (typeof posthog.init !== 'function') {
        return;
      }
      posthog.init(String(key).trim(), {
        api_host: apiHost,
        person_profiles: 'identified_only',
        session_recording: {
          recordCrossOriginIframes: true,
          capturePerformance: false,
        },
      });
      window.posthog = posthog;
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('[analytics] PostHog não carregou:', e);
      }
    }
  })();
}

function initMetaPixel() {
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  if (!pixelId || String(pixelId).trim() === '') {
    return;
  }

  const id = String(pixelId).trim();

  if (typeof window === 'undefined' || window.fbq) {
    return;
  }

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', id);
  window.fbq('track', 'PageView');
}

export function initAnalytics() {
  initPostHog();
  initMetaPixel();
}
